import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function SaveOutline(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M.3 7.827c0-3.475 2.776-6.312 6.225-6.312 2.37 0 4.423 1.34 5.475 3.307 1.052-1.967 3.104-3.307 5.475-3.307 3.449 0 6.225 2.837 6.225 6.312 0 4.16-1.96 7.21-4.336 9.5-1.846 1.78-4 3.146-5.692 4.22-.457.29-.881.559-1.256.809a.75.75 0 01-.832 0 67.473 67.473 0 00-1.28-.823c-1.688-1.069-3.83-2.425-5.668-4.193C2.26 15.055.3 12.004.3 7.827zm10.95 0c0-2.669-2.127-4.812-4.725-4.812-2.599 0-4.725 2.143-4.725 4.812 0 3.644 1.69 6.33 3.876 8.432 1.715 1.65 3.679 2.895 5.355 3.957.336.213.66.418.969.618.3-.194.614-.394.94-.601 1.683-1.069 3.659-2.324 5.383-3.986 2.188-2.108 3.877-4.794 3.877-8.42 0-2.669-2.127-4.812-4.725-4.812-2.599 0-4.725 2.143-4.725 4.812a.75.75 0 01-1.5 0z"
  }));
}

export { SaveOutline };
//# sourceMappingURL=SaveOutline.js.map